import { AuditEvent, JiraTestSuite } from '../../interfaces/ui/testPlan';

const parseJiraDate = (value: unknown): Date | undefined => {
  if (typeof value !== 'string' || !value.trim()) return undefined;
  const parsedDate = new Date(value);
  return Number.isNaN(parsedDate.getTime()) ? undefined : parsedDate;
};

const mapAuditEvent = (
  auditData: any,
  userKey: 'createdBy' | 'updatedBy',
  dateKey: 'createdOn' | 'updatedOn',
): AuditEvent | undefined => {
  if (!auditData) return undefined;

  const by = auditData.by || auditData[userKey];
  const on = parseJiraDate(auditData.on || auditData[dateKey]);

  if (!by || !on) return undefined;

  return {
    by,
    on,
  };
};

export function mapTestSuiteResponse(response: any) {
  if (!response) {
    return [];
  }

  const suiteData = response?.data?.testsuites?.value;

  if (!suiteData) return [];

  return suiteData.map((testSuite: any) => {
    return {
      id: testSuite.id,
      name: testSuite.name,
      suiteType: testSuite.suiteType,
      parentSuiteId:
        testSuite.parentSuiteId?.toString() ||
        testSuite.parentSuite?.id?.toString(),
      lastUpdatedDate: new Date(testSuite.lastUpdatedDate),
      revision: testSuite.revision,
      testCasesUrl: testSuite.testCasesUrl,
    };
  });
}

export function mapJiraTestSuites(testSuiteData: any[]): JiraTestSuite[] {
  return testSuiteData.map(testSuite => {
    return {
      id: testSuite.id,
      name: testSuite.name,
      sequence: testSuite.sequence ?? testSuite.seqNo,
      parentId: testSuite.parentId?.toString(),
      children: mapJiraTestSuites(testSuite.children || []),
      created: mapAuditEvent(testSuite.created, 'createdBy', 'createdOn'),
      updated: mapAuditEvent(testSuite.updated, 'updatedBy', 'updatedOn'),
    };
  });
}
